import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const leadApi = {
  getLeads: async ({ page = 1, perPage = 10, search = '', includeTrashed = false, paginate = true } = {}) => {
    try {
      const params = { search, trashed: includeTrashed ? 'true' : 'false' };
      if (paginate) {
        params.page = page;
        params.per_page = perPage;
      } else {
        params.paginate = false;
      }

      const response = await apiClient.get(`${API_ENDPOINTS.LEADS}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching leads:', error);
      throw error;
    }
  },

  getLeadByIdentifier: async (identifier) => {
    try {
      const url = `${API_ENDPOINTS.LEADS}/${identifier}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching lead ${identifier}:`, error);
      throw error;
    }
  },

  getLeadHistory: async (leadId) => {
    try {
      const url = `${API_ENDPOINTS.LEADS}/${leadId}/history`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching lead history for lead ${leadId}:`, error);
      throw error;
    }
  },

  updateLeadHistory: async (leadId, historyData) => {
    try {
      const url = `${API_ENDPOINTS.LEADS}/${leadId}/history`;
      const response = await apiClient.post(url, historyData);
      return response.data;
    } catch (error) {
      console.error(`Error updating lead history for lead ${leadId}:`, error);
      throw error;
    }
  },

  trashLead: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.LEADS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing lead ${identifier}:`, error);
      throw error;
    }
  },

  restoreLead: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.LEADS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring lead ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteLead: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.LEADS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting lead ${identifier}:`, error);
      throw error;
    }
  },
};

export default leadApi;